const colors = {
  green: {
    primary: "#41C78F",
    secondary: "#1ACD57",
    tertiary: "#01ab7d",
    quaternary: "#017556",
    quinary: "#01AB7D",
    senary: "#01906a",
    /** Brand primary-light — XP badge fill / concluded badge border (Figma Novo onboarding) */
    light: "#B3E6D8",
    /** Brand primary-dark — concluded badge label (Figma Novo onboarding) */
    dark: "#017858",
    quaternary_text: "#01563f",
  },
  gray: {
    primary: "#898989",
    secondary: "#878995",
    tertiary: "#CCCCCC",
    quaternary: "#EFF3F2",
    quinary: "#EBEDF3",
    senary: "#E6E9EC",
    septenary: "#FAF9F9",
    octonary: "#F9FBFD",
    nonary: "#EEFAF5",
    denary: "#5A5A5A",
    undenary: "#A0A2A9",
    duodenary: "#96979F;",
    tredecimal: "#F3F6F9",
    quattuordecimal: "#f9f9f9",
    quindecimal: "#B9B9B9",
  },
  red: {
    primary: "#DE5462",
    secondary: "#F64E60",
    tertiary: "#DD2025",
    quaternary: "#F0431B",
    quinary: "#D83143",
    senary: "#E94F0E",
  },
  black: {
    primary: "#111219",
    secondary: "#161C24",
    tertiary: "#404149",
    quaternary: "#3F4254",
    quinary: "#131313",
    textDark: "#383839",
  },
  white: {
    primary: "#FFFFFF",
    secondary: "#F8FAFD",
    tertiary: "#FAFAFA",
    quaternary: "#FFF",
    quinary: "#FAF9F9",
    senary: "#FAFBFF",
  },
  blue: {
    primary: "#091740",
    secondary: "#2e3f75",
    tertiary: "#05BDFA",
    quaternary: "#091D5C",
    quinary: "#0089B7",
    senary: "#091D5C",
  },

  yellow: {
    primary: "#F49200",
  },

  backgrounds: {
    active: "#E6F7F2",
    inactive: "#FBEAEC",
    default: "#F4F5F9",
  },

  brand: {
    primary: {
      main: "#01AB7D",
    },
  },

  sidebar: {
    background: "#fafffe",
  },

  designSystem: {
    gray: {
      0: "#ffffff",
      50: "#fafbff",
      100: "#f4f5f9",
      200: "#eaecf1",
      /** Borda canônica de card (`card.border` do design system). */
      250: "#e7e8ec",
      /** Mesmo valor de `gray.quinary` (119 usos no app). Existe aqui para o
       *  código novo não precisar alcançar o namespace legado. */
      300: "#ebedf3",
      400: "#ceced2",
      500: "#bbbcbf",
      600: "#838486",
      700: "#5e5e60",
      800: "#383839",
      900: "#1a1a1a",
      950: "#131313",
    },
    green: {
      25: "#fafffe",
      50: "#f3fbf8",
      100: "#e6f7f2",
      150: "#d6f1e7",
      200: "#b3e6d8",
      300: "#56c189",
      400: "#34bc97",
      500: "#01ab7d",
      600: "#019970",
      700: "#017858",
      900: "#01563f",
    },
    /** Acentos frios usados nos degradês da IA (Dashboard v2). */
    teal: {
      400: "#12a38c",
      500: "#0e9da8",
      600: "#0b8fb4",
    },
    /** Atenção / prazo correndo (semântica da Dashboard v2). */
    orange: {
      100: "#fdede7",
      200: "#f8dcd0",
      500: "#f35b08",
      600: "#ce4d07",
    },
    blue: {
      50: "#f1f8ff",
      100: "#e6f3f7",
      /** Borda da faixa de aviso do modo leitura (FT-919). */
      200: "#b3dae6",
      300: "#739bbf",
      500: "#0182ab",
      /** Texto/ícone da faixa de aviso do modo leitura (FT-919). */
      700: "#015b78",
      900: "#014156",
    },
    red: {
      50: "#fef2f2",
      500: "#d83143",
    },
    yellow: {
      100: "#fff9e6",
      400: "#ccba7a",
      500: "#ffc700",
      600: "#f5b301",
      700: "#b38b00",
    },
    purple: {
      100: "#eee4fe",
      /** Roxo da IA na Dashboard v2 (400 base, 600 hover). */
      400: "#5a3fb0",
      500: "#4f05be",
      600: "#4a3396",
      900: "#290066",
    },
  },
};

export default colors;
